import React, { useEffect, useState } from 'react';
import { GetServices } from '../services/cms.services';

const SERVICE_CONTENT = [
  {
    title: 'fertility injection concierge',
    subCategories: [
      'IVF injection services',
      'Egg-freezing injection services',
    ],
  },
  {
    title: 'self-care',
    subTitle: '(pregnancy, postpartum + everyday)',
    subCategories: [
      'At Home massage \'The Recovery\'',
      'Doula',
      'Night Nanny',
    ],
  },
  {
    title: 'child care',
    subCategories: [
      'Babysitter',
      'Nanny',
      'Specialty nanny (summer, event, travel, special support)',
    ],
  },
  {
    title: 'senior care',
    subCategories: [
      'Companionship',
      'At home support',
    ],
  },
];

const INCLUDED_ITEMS = [
  'Access to babe’s connection platform and network of professionals',
  'babe. Associates with mandatory enhanced background checks',
  'License verified Registered Nurses (RNs) and Massage Therapists',
  'Elevated safety measures upon appointment check-ins (in-app security scans)',
  'Unlimited connections (no cap)',
  {
    id: 'messaging',
    content: (
      <>
        Unlimited messaging, <em>on your terms</em>. babes message first.
      </>
    ),
  },
  'Connections you control. Swipe to refine your matches.',
  'Straightforward and competitive appointment pricing',
  'babe. Pay (coming soon)',
];

const INCLUDED_ITEMS_2 = [
  'Access to babe’s connection platform. Your new side hustle delivered.',
  'Easily collect your appointment earnings',
  'Simplified background check process*',
  'Effortless license verification for Registered Nurses (RNs) and Massage Therapists',
  'Elevated safety measures upon appointment check-ins (in-app security scans)',
  'Unlimited connections (no cap)',
  'Unlimited messaging with connections',
  'Straightforward and competitive appointment compensation',
  'Control your schedule. When you can, where you want - ultimate flexibility.',
  'Fair nanny compensation, we’re upholding the integrity of the nanny industry with our ‘babe standard’ ($22/hour minimum)',
  'Streamlined onboarding',
  'babe. Pay (coming soon)',
];

function WhatIncluded() {
  const [services, setServices] = useState([]);

  useEffect(() => {
    GetServices().then((response) => {
      if (response.success) {
        setServices(response.data);
      } else {
        console.error('error', response);
      }
    }).catch((err) => {
      console.error('err', err);
    });
  }, []);

  return (
    <main className='what-included-page'>

      <section className="what-included-hero section-padding">
        <div className="container">
          <div>
            <span className="subheading">The babe. app</span>
            <h2 className="h2 ink mt-2">babe, here’s what’s <span> included.</span></h2>

            <h3 className="h3 fuschia">babe. subscription - $22.99/month</h3>

            <ul className=" what-included-list ink">
              {INCLUDED_ITEMS.map((item) => (
                <li key={typeof item === 'string' ? item : item.id}>
                  {typeof item === 'string' ? item : item.content}
                </li>
              ))}
            </ul>

            <h3 className="h3 fuschia">babe. Associate subscription - $22.99/month</h3>

            <ul className=" what-included-list ink">
              {INCLUDED_ITEMS_2.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>

            <div className="what-included-services mt-5">
              <div className="row row-gap-4">
                {SERVICE_CONTENT.map((item, index) => (
                  <div className="col-xl-3 col-md-6 d-flex flex-column" key={index}>
                    <div className="care-box">
                      <div className="icon-box">
                        <img
                          className="w-100"
                          src={services?.[index]?.image}
                          alt={item.title}
                        />
                      </div>

                      <h4 className="fs-5 ink mb-3">
                        {item.title}
                        {item.subTitle && (
                          <span className="d-block small">
                            {item.subTitle}
                          </span>
                        )}
                      </h4>

                      <ul className="custom-bullets">
                        {item.subCategories.map((subItem, subIndex) => (
                          <li key={subIndex}>{subItem}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                ))}
              </div>
            </div>

          </div>
        </div>
      </section>


      <div className='what-included-page-footer pb-4'>
        <div className='container'>
          <p className='ink fw-medium'>*Pending promotion; background check fee may apply</p>
          <p className='ink fw-medium mt-0'>Please note all services carry an additional cost outside of the monthly subscription fee.</p>
        </div>
      </div>

    </main>
  );
}

export default WhatIncluded;
